import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import compose from 'ramda/src/compose'
import path from 'ramda/src/path'

const responseLenses = getResponseLenses(GET_PROJECT)
const { viewMyFavorites } = responseLenses

export default (state) => {
	const recordId = currentRouteParamsRecordId(state)

	return compose(
		viewMyFavorites,
		path(['api', 'records', 'project', recordId]),
	)(state)
}
